module.exports = __webpack_public_path__ + "static/img/mjcafe.3287b031.png";